/**
 * The rule that keeps OMJ VISION invite-only.
 *
 * `/sign-up/*` exists only because Clerk's invitation email lands there with a
 * `__clerk_ticket` in the query string, and `<SignUp>` is the component that
 * redeems it. Everyone else arriving at that address is turned away.
 *
 * Kept apart from the page so it can be tested without pulling in Clerk's
 * widget, which needs a provider and a network round trip.
 */

/**
 * Is this someone trying to register themselves, rather than an invited user?
 *
 * Only the start route (`/sign-up`, trailing slash or not) is judged. Clerk
 * navigates to the sub-steps — `/sign-up/continue`,
 * `/sign-up/verify-email-address` — itself, without carrying the ticket along,
 * so judging those would break activation midway. They are safe to let render:
 * with no sign-up attempt in progress Clerk returns to the start route, where
 * this rule catches it.
 *
 * @param {string} pathname
 * @param {string} search
 * @returns {boolean}
 */
export function isPublicRegistrationAttempt(pathname, search) {
  const isStartRoute = String(pathname).replace(/\/+$/, "") === "/sign-up";
  const hasTicket = Boolean(new URLSearchParams(search || "").get("__clerk_ticket"));

  return isStartRoute && !hasTicket;
}

export default isPublicRegistrationAttempt;
